// extracted by mini-css-extract-plugin
module.exports = {"text":"SignOut_text__FhXEe","wrap":"SignOut_wrap___86sG","button":"SignOut_button__AZBNT"};